<!-- 文件的树形结构 -->
<template>
  <div class="PublicFileTree">
    <div class="FileTreeTop">
      <!--拖拽头部标题-->
      <div class="searchTitle">
        <!-- 头部标题 -->
        <div style="margin-right:15px">
          <i class="iconfont icon-search pointer" @click="goToLogin('welcomeMediaSearch')" :title="$t('lang.search')"></i>
          <el-tooltip placement="top" effect="light" popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.addFolder") }}</div>
            </div>
            <i class="iconfont icon-addfolder" @click="goToLogin('welcomeMediaAddFolder')"></i>
          </el-tooltip>
          <el-tooltip placement="top" effect="light" popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.uploadVideoLocal") }}</div>
            </div>
            <i class="iconfont pointer" @click="goToLogin('welcomeMediaAddVideo')">&#xe6ce;</i>
          </el-tooltip>
        </div>
      </div>
      <!-- 搜索框 -->
      <div class="searchInput" v-if="fileInput">
        <el-input v-model="searchFileParam.condition" :placeholder="$t('lang.fileName')" class="SearchInput" @change="getSearchFile"></el-input>
        <i class="iconfont icon-search pointer" @click="getSearchFile"></i>
      </div>
    </div>
    <!-- 下面的文件树 -->
    <div class="FileTreeScroll">
      <div class="draggable_box">
        <div class="FileTree" v-if="!searchFileParam.IsSearch">
          <!-- 加key区分两个树，不进行复用 -->
          <el-tree :props="props" lazy :load="loadNode" @node-click="getCurrentNode" :key="1" empty-text="No Data">
            <div class="TreeWrap" slot-scope="{ node, data }">
              <div v-if="!data.noData">
                <div class="folderItem" v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">
                    {{ node.label }} {{ data.mediaCount ? " (" + data.mediaCount + ")" : "" }}
                  </p>
                  <div class="folderOperation">
                    <i class="iconfont icon-addfolder" @click.stop="goToLogin('welcomeMediaAddFolder')"></i>
                    <i class="iconfont icon-12-copy-copy" @click.stop="goToLogin('welcomeMediaEditFolder')"></i>
                    <i class="iconfont icon-icon14" @click.stop="goToLogin('welcomeMediaDeleteFolder')"></i>
                  </div>
                </div>
                <div class="draggable_item draggableFile" draggable="true" :data-device="JSON.stringify(data)" v-else>
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                  <div class="fileOperation">
                    <div class="IconWrap">
                      <i class="iconfont icon-12-copy-copy" @click.stop="goToLogin('welcomeMediaEditFile')"></i>
                      <i class="iconfont icon-icon14" @click.stop="goToLogin('welcomeMediaDeleteFile')"></i>
                    </div>
                    <div class="FileTime">
                      {{ formatSeconds(data.videoTimes) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="noData" v-else>
                {{ $t('lang.noData') }}
              </div>
            </div>
          </el-tree>
        </div>
        <div class="searchFileTree" v-else>
          <el-tree :data="searchFileList" :props="searchListProps" :default-expand-all="true" @node-click="getCurrentNode" :key="2">
            <div class="TreeWrap" slot-scope="{ node, data }">
              <div>
                <div class="folderItem" v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                </div>
                <div class="draggable_item draggableFile" draggable="true" :data-device="JSON.stringify(data)" v-else>
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                  <div class="fileOperation">
                    <div class="IconWrap">
                      <i class="iconfont icon-12-copy-copy" @click.stop="changeFile(node)"></i>
                      <i class="iconfont icon-icon14" @click.stop="deleteFile(node)"></i>
                    </div>
                    <div class="FileTime">
                      {{ formatSeconds(data.videoTimes) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tree>
        </div>

        <EditMedia v-if="editMedia.show" :data="editMedia" @queryFile="operationSuccess"></EditMedia>
        <AddEditFolder v-if="editFolder.show" @queryFolder="operationSuccess" :data="editFolder"></AddEditFolder>
        <!-- 上传视频   -->
        <UploadVideo v-show="uploadVideo.show" :data="uploadVideo" :session="uploadVideo.session" @queryList="operationSuccess('add')"></UploadVideo>
      </div>
    </div>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import EditMedia from '@/components/file/EditMedia'
import AddEditFolder from '@/components/file/AddEditFolder'
import UploadVideo from '@/views/Playout/UploadVideo/UploadVideo'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import { creatAccount } from '@/assets/js/common/creatAccount.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
// import { searchIframe } from '@/assets/js/TVUSearch'
export default {
  props: {
    // 刷新节点
    renderNode: {
      type: Number,
      default: 0
    }
  },
  computed: mapState({
    State: (state) => state
  }),
  data () {
    return {
      // true文件false搜索文件
      FileTree: true,
      // bucketId
      bucketId: '',
      // 列表配置
      props: {
        label: 'name',
        children: 'childNodes',
        isLeaf: 'directory'
      },
      // 第一级id
      NodeHeadId: 0,
      // 存储所有点开的父级节点
      parentMap: {},
      // 当前节点
      presentNode: {},
      // 文件夹的操作信息
      editFolder: {
        show: false,
        name: '',
        parentId: '',
        id: '',
        type: 0 // 0创建 1编辑
      },
      // 文件的操作信息
      editMedia: {
        show: false
      },
      // 搜索信息
      searchFileParam: {
        condition: '',
        IsSearch: 0
      },
      // 是否显示搜索框
      fileInput: false,
      // 搜索到的列表
      searchFileList: [],
      // 搜索列表显示配置
      searchListProps: {
        label: 'name',
        children: 'sonFileInfo'
      },
      // 上传视频
      uploadVideo: {
        show: false,
        session: window.localStorage.getItem('channelSession')
      },
      // 文件列表
      filterList: []
    }
  },
  components: {
    EditMedia,
    AddEditFolder,
    UploadVideo
  },
  watch: {
    // 刷新第一层节点
    renderNode (item) {
      this.$nextTick(() => {
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.operationSuccess()
      })
    }
  },
  created () { },
  mounted () {
    this.filterList = [
      {
        directory: true,
        id: 'b8033031e72b44e189e6b81805e50a7c',
        name: 'Make your stories come alive',
        type: 'Video',
        url: 'https://pp-va-001.s3.amazonaws.com/d8c2d18d71024ba289dec41529ae5247/Promo/TVU%20Promo%20Compilation%2060%20Minutes%2010-28-21.mp4',
        videoTimes: '3600',
        videoUrls: 'https://pp-va-001.s3.amazonaws.com/d8c2d18d71024ba289dec41529ae5247/Promo/TVU%20Promo%20Compilation%2060%20Minutes%2010-28-21.mp4',
        visible: true
      },
      {
        directory: true,
        id: '190960c6703944568c6f8e2cd4a693e4',
        name: 'TVU Partyline.mov',
        type: 'Video',
        url: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/TVU%20Partyline.mov',
        videoTimes: '1264',
        videoUrls: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/TVU%20Partyline.mov',
        visible: true
      },
      {
        directory: true,
        id: '209a21679ed94cd99a0c3f321b94f31f',
        name: 'Live Video in the Cloud.mp4',
        type: 'Video',
        url: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/Live%20Video%20in%20the%20Cloud.mp4',
        videoTimes: '4377',
        videoUrls: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/Live%20Video%20in%20the%20Cloud.mp4',
        visible: true
      },
      {
        directory: true,
        id: '2daa10db6a7d4c96bbe9185a8035f8b7',
        name: 'Fremont Fire Deptartment.mov',
        type: 'Video',
        url: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/Fremont%20Fire%20Deptartment.mov',
        videoTimes: '188',
        videoUrls: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/Fremont%20Fire%20Deptartment.mov',
        visible: true
      },
      {
        directory: true,
        id: '4e7ca33ea1524697afd564739cab8ef4',
        name: 'Remote Commentator.mp4',
        type: 'Video',
        url: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/Remote%20Commentator.mp4',
        videoTimes: '1857',
        videoUrls: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/Remote%20Commentator.mp4',
        visible: true
      },
      {
        directory: true,
        id: '1e6dc249607c4435916f062467f6cd01',
        name: 'TVU Home Studio.mov',
        type: 'Video',
        url: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/TVU%20Home%20Studio.mov',
        videoTimes: '289',
        videoUrls: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/TVU%20Home%20Studio.mov',
        visible: true
      },
      {
        directory: true,
        id: '92a6054e96b04f988c033fb8f47fec42',
        name: 'At-Home Remi Wireless.mp4',
        type: 'Video',
        url: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/At-Home%20Remi%20Wireless.mp4',
        videoTimes: '2602',
        videoUrls: 'https://ch-or-001.s3.us-west-2.amazonaws.com/324a919886dc409a942b646fa3dbcbeb/Videos/At-Home%20Remi%20Wireless.mp4',
        visible: true
      }
    ]
    localStorage.setItem('WelcomeFile', JSON.stringify(this.filterList))
  },
  methods: {
    goToLogin (tag) {
      creatAccount()
      playoutAnalyze(tag)
    },
    // 懒加载节点内容
    loadNode (node, resolve) {
      // 存储所有点开的父级节点
      this.parentMap[node.id] = {
        node,
        resolve
      }
      // 一级节点处理
      if (node.level === 0) {
        this.NodeHeadId = node.id
        this.getNodeContent(0, resolve)
      }
      // 其余节点的处理
      if (node.level >= 1) {
        this.getNodeContent(node, resolve)
      }
    },
    // 让:load=loadNode 重复触发  动态更新tree
    requestNewData (presentNode) {
      this.$set(presentNode.node, 'childNodes', []) // 把存起来的node的子节点清空，不然会界面会出现重复树！);
      this.loadNode(presentNode.node, presentNode.resolve) // 再次执行懒加载的方法
    },
    // 获取节点内容
    getNodeContent (data, resolve) {
      let param
      if (data) {
        param = {
          parentId: data.data.id,
          objectKey: data.data.objectKey
        }
        resolve(this.filterList)
      } else {
        param = {
          parentId: 0,
          bucketCode: this.$store.state.buketId
        }
        const filterList = [{
          directory: false,
          id: '8124eb086c06443bba78bdc288348c82',
          name: 'PROGRAMMING',
          parentId: '26532540190720',
          mediaCount: 7,
          visible: true
        }]
        resolve(filterList)
      }
      this.$nextTick(() => {
        Bus.$emit('leftListUpdate')
      })
    },
    // 过滤文件夹
    FilterFolder (folderList) {
      let FileList = []
      const ProgramRMessage = localStorage.getItem('ProgramRMessage')
      let showFolders
      if (ProgramRMessage) {
        showFolders = JSON.parse(ProgramRMessage).showFolders
      }
      if (showFolders) {
        showFolders = showFolders.toUpperCase()
        const folderNameList = showFolders.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
        return FileList
      }
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      if (urlInfo.folderNameList) {
        const folderName = urlInfo.folderNameList.toUpperCase()
        const folderNameList = folderName.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
      }
      return FileList
    },
    // 搜索显示
    searchShow () {
      this.fileInput = !this.fileInput
      this.searchFileParam.condition = ''
      if (this.searchFileParam.IsSearch) {
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.operationSuccess()
      }
      this.searchFileParam.IsSearch = 0
    },
    // 搜索文件
    getSearchFile () {
      this.searchFileParam.IsSearch++
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolderAndMediasByCondition',
          {
            condition: this.searchFileParam.condition,
            parentId: 0,
            bucketCode: this.$store.state.buketId
          },
          {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const FileList = this.FilterFolder(res.data.result)
            // 去除不应该显示的文件
            const filterList = FileList.filter((item) => item.visible)
            this.searchFileList = filterList
            this.$nextTick(() => {
              Bus.$emit('leftListUpdate')
            })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
    },
    // 文件编辑
    changeFile (node) {
      this.editMedia = {
        ...node.data,
        show: true
      }
      // 不是搜索的文件进行编辑
      if (!this.searchFileParam.IsSearch) {
        // 编辑文件存父级节点
        this.presentNode = node.parent
      }
    },
    // 获取录制文件信息
    getRecordMessage (file) {
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/record/search/info',
          {
            name: file.name
          },
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.SearchEditing(res.data.result)
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
    },
    // 引入TVUSearch
    SearchEditing (file) {
      const session = localStorage.getItem('channelSession')
      const url = 'https://search.tvunetworks.com/search/#/indexSearch?iframe=true'
      const data = file
      data.session = session
      const input = {
        version: '1.0',
        messageType: 'mark',
        origin: 'playout',
        data
      }

      searchIframe({
        open: () => [session, url, input],
        event: (e) => {
          console.log(e)
        },
        error: (e) => {
          console.log(e)
        },
        close: () => {
          console.log('close close ')
        }
      })
    },
    // 对文件夹进行操作
    changeFolder (type, node) {
      if (type) {
        // // 判断某些文件需要使用tvu-search
        // if (node.data.name == 'BreakingLiveSource' || (node.parent && node.parent.data.name == 'BreakingLiveSource')) {
        //   if (node.data.name == 'BreakingLiveSource') {
        //     this.$message.warning(this.$t('lang.folderNonsupport'))
        //   } else {
        //     this.getRecordMessage(node.data)
        //   }
        //   // 编辑文件夹存父级节点
        //   this.presentNode = node.parent
        // } else {
        //   this.editFolder = {
        //     show: true,
        //     name: node.data.name,
        //     parentId: node.data.id,
        //     id: node.data.id,
        //     type: 1
        //   }
        //   // 编辑文件夹存父级节点
        //   this.presentNode = node.parent
        // }
        this.editFolder = {
          show: true,
          name: node.data.name,
          parentId: node.data.id,
          id: node.data.id,
          type: 1
        }
        // 编辑文件夹存父级节点
        this.presentNode = node.parent
      } else {
        this.editFolder = {
          show: true,
          name: '',
          parentId: node.data.id,
          id: '',
          type: 0
        }
        // 新增文件夹存当前节点
        this.presentNode = node
      }
    },
    // 文件和文件夹操作成功
    operationSuccess (fileType) {
      // fileType文件操作类型 add,compile,delete 文件操作  Folder文件夹
      // 是否事搜索的文件操作
      if (this.searchFileParam.IsSearch) {
        this.getSearchFile()
      } else {
        // 文件移动到其他文件夹
        if (fileType === 'compile' || fileType === 'add' || (fileType == 'Folder' && !this.editFolder.type)) {
          this.presentNode = {
            id: this.NodeHeadId
          }
        }
        const getNode = this.parentMap[this.presentNode.id]
        // 文件删除
        if (fileType === 'delete') {
          getNode.node.data.mediaCount--
        }
        if (getNode) {
          this.requestNewData(getNode)
        }
      }
    },
    // 点击文件预览视频
    getCurrentNode (data, node) {
      if (data.url) {
        this.$emit('SetPreviewVideo', data, 'Media')
      }
    },
    // 新增文件夹
    showAddFolder () {
      this.editFolder = {
        show: true,
        name: '',
        parentId: '0',
        id: '',
        type: 0
      }
    },
    // 上传视频
    showUploadVideo () {
      this.uploadVideo.show = true
    },
    // 删除文件夹
    deleteFolder (node) {
      this.$confirm(this.$t('lang.deleteFloder'), '', {
        confirmButtonText: this.$t('lang.Ok'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        // 编辑文件夹存父级节点
        this.presentNode = node.parent
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/deleteFolder',
            {
              id: node.data.id,
              sessionId: localStorage.getItem('channelSession')
            },
            {
              contentType: 'application/json;charset=UTF-8'
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.operationSuccess()
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          })
      })
    },
    // 删除文件
    deleteFile (node) {
      this.$confirm(this.$t('lang.deleteMediaList'), '', {
        confirmButtonText: this.$t('lang.Ok'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        // 不是搜索的文件进行编辑
        if (!this.searchFileParam.IsSearch) {
          // 编辑文件存父级节点
          this.presentNode = node.parent
        }
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/schedule/event/exist/check',
            {
              fileId: node.data.id
            },
            {
              contentType: 'application/json;charset=UTF-8'
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              // 判断是否可以直接删除
              if (res.data.result != null) {
                this.$confirm(`Clip ${res.data.result.nickName} is used in an active schedule item.   Are you sure that you want to delete it?`, '', {
                  confirmButtonText: this.$t('lang.Ok'),
                  cancelButtonText: this.$t('lang.cancel'),
                  type: ''
                }).then(() => {
                  this.AgainDeleteFile(node, 'UpdateEvent')
                })
              } else {
                this.AgainDeleteFile(node)
              }
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          })
      }).catch(() => { })
    },
    // 再一次删除文件
    AgainDeleteFile (node, update) {
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/file/delete',
          {
            fileId: node.data.id
          },
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            if (update == 'UpdateEvent') {
              // 通过websocket通知更新event
              this.$BehaviorSyns.SendBehavior('EventListChange', 1)
            }
            this.operationSuccess('delete')
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
    },
    formatSeconds (i) {
      const second = Number(i)
      const flag = String(second).indexOf('.') + 1
      let decimal = '00'
      if (flag > 0) {
        decimal = Math.floor(second * 29.97 - parseInt(second) * 29.97)
        if (decimal < 10) {
          decimal = `0${decimal}`
        }
      }

      let s = parseInt(second) // 需要转换的时间秒
      let m = 0 // 分
      let h = 0 // 小时
      if (s > 60) {
        m = parseInt(s / 60)
        s = parseInt(s % 60)
        if (m > 60) {
          h = parseInt(m / 60)
          m = parseInt(m % 60)
        }
      }

      let ss,
        mm,
        hh
      if (s > 0) {
        ss =
          s.toString().length >= 2
            ? s.toString()
            : `0${s.toString()}`
      } else {
        ss = '00'
      }

      if (m > 0) {
        mm =
          m.toString().length >= 2
            ? m.toString()
            : `0${m.toString()}`
      } else {
        mm = '00'
      }

      if (h > 0) {
        hh =
          h.toString().length >= 2
            ? h.toString()
            : `0${h.toString()}`
      } else {
        hh = '00'
      }
      const result = `${hh}:${mm}:${ss}:${decimal}`
      return result
    }
  }
}
</script>

<style scoped lang="less">
.PublicFileTree {
  i {
    color: #cccccc;
  }
  .FileTreeTop {
    .searchTitle {
      padding: 12px 0 10px 0;
      border-bottom: 2px solid #555;
      text-align: right;
      i {
        margin: 0 4px;
        color: #cccccc;
      }
    }
    .searchInput {
      position: relative;
      i {
        position: absolute;
        right: 12px;
        font-size: 20px;
        top: 7px;
        z-index: 1001;
      }
    }
  }
  .FileTreeScroll {
    height: 518px;
    overflow-y: auto;
  }
  .FileTreeScroll::-webkit-scrollbar:horizontal {
    display: none;
  }
  .draggable_box {
    margin-top: 5px;
    ::v-deep .el-tree {
      .el-tree-node__content {
        height: 32px;
        .el-icon-caret-right:before {
          font-size: 16px;
        }
        .el-icon-loading {
          display: none;
        }
      }
      .TreeWrap {
        width: 95%;
        .folderItem,
        .draggable_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 32px;
          .fileTitle {
            width: 60%;
            font-size: 12px;
            color: #cccccc;
            text-align: left;
            overflow: hidden;
            margin: 0;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .folderOperation {
            width: 30%;
            i {
              font-size: 16px;
              margin-right: 6px;
            }
          }
          .fileOperation {
            width: 30%;
            padding-right: 13px;
            .IconWrap {
              display: none;
              i {
                font-size: 16px;
                margin-right: 6px;
              }
            }
            .FileTime {
              font-size: 12px;
              color: #cccccc;
              line-height: 14px;
              display: block;
            }
            // .FileTimeOld {
            //     font-size: 12px;
            //     color: #cccccc;
            //     line-height: 14px;
            //     display: block;
            // }
          }
        }
        .draggable_item:hover .fileOperation {
          .IconWrap {
            display: block;
          }
          .FileTime {
            display: none;
          }
        }
      }
    }
  }
}
</style>
